<script setup>
import BaseUrl from '~/api/BaseUrl.js';
import ENDPOINTS from '~/api/endpoints/index.js';
import Headers from '~/api/Headers.js';
import { useRoute } from 'vue-router';
import { useSnackbarStore } from '~/stores/snackbarInfo.js';

const { videoUrl, headerText, subHeadingText } = defineProps([
  'videoUrl',
  'headerText',
  'subHeadingText',
]);
const inputVideoUrl = ref(`${videoUrl ?? ''}`);
const previewMode = ref(false);
const emit = defineEmits(['close', 'update-video']);

const handleInput = (value) => {
  // Remove http:// and https:// from the input
  const cleaned = value.replace(/^(http:\/\/|https:\/\/)/i, '');
  inputVideoUrl.value = cleaned;
};
const route = useRoute();
const snackbar = useSnackbarStore();
const saveVideo = async () => {
  snackbar.setSnackbar('Updating page video', 'info', 2000);
  const url = `${BaseUrl.get(ENDPOINTS.EVENTS.UPSERT_FUNDRAISER_PAGE_INFO)}${ENDPOINTS.EVENTS.UPSERT_FUNDRAISER_PAGE_INFO}?event_id=${route.params.id}&fundraiser_id=${route.params.fundraiser_id}`;
  try {
    await $fetch(url, {
      headers: Headers,
      credentials: 'include',
      method: 'post',
      body: JSON.stringify({ page_video: inputVideoUrl.value }),
    });
    snackbar.setSnackbar('Page video updated successfully', 'success', 2000);
    emit('update-video', 'https://' + inputVideoUrl.value);
    emit('close');
  } catch (error) {
    console.warn(e);
    snackbar.setSnackbar(
      e.data ?? e?.message ?? e?.errorMessage ?? 'Unable to update page',
      'error',
      2000,
    );
  }
};
</script>
<template>
  <v-row>
    <v-col>
      <v-row :class="{ 'mb-1': !subHeadingText }" v-if="headerText">
        <v-col>
          <h5>
            {{ headerText }}
          </h5>
        </v-col>
      </v-row>
      <v-row no-gutters v-if="subHeadingText" class="mb-1">
        <v-col>
          <p style="font-style: italic; font-size: 14px">{{ subHeadingText }}</p>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col sm="10">
          <v-row>
            <v-col sm="auto">
              <img src="/youtube.png" style="height: 50px" />
            </v-col>
            <v-col sm="auto">
              <img src="/vimeo.png" style="height: 50px" />
            </v-col>
          </v-row>
          <v-row class="align-center mt-0">
            <v-col sm="9">
              <v-text-field
                solo
                variant="outlined"
                density="compact"
                class="position-relative w-100"
                hide-details
                v-model="inputVideoUrl"
                @update:model-value="handleInput"
              >
                <template v-slot:prepend-inner>
                  <span> https:// </span>
                </template>
              </v-text-field>
            </v-col>
            <v-col sm="3">
              <v-btn
                elevation="1"
                variant="outlined"
                color="success"
                prepend-icon="mdi-eye"
                :disabled="!inputVideoUrl"
                @click="previewMode = true"
              >
                Preview
              </v-btn>
            </v-col>
          </v-row>
          <v-row v-if="previewMode">
            <v-col>
              <VideoPlayer :video-url="inputVideoUrl" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <div class="d-flex justify-end">
        <v-btn color="success" class="text-transform-none mt-4" @click="saveVideo"
          >Save & Continue</v-btn
        >
      </div>
    </v-col>
  </v-row>
</template>
